// PowerSync — visual_analyses metadata (thumbnailUrl — server-presigned, offline = null).
import { usePowerSyncQuery } from "@/lib/powersync/use-query";
import { belongsToLiveMaterial } from "../live-material-sql";

export interface LocalVisualAnalysis {
	id: string;
	user_id: string;
	title: string | null;
	category: string | null;
	status: string;
	image_url: string | null;
	created_at: string;
	updated_at: string;
	deleted_at: string | null;
}

export function useVisualAnalysesQuery(userId: string | undefined) {
	// Разбор удалённого материала уходит вместе с ним (серверный каскад) —
	// предикат делает это мгновенным, не дожидаясь круга синка. Разбор,
	// загруженный картинкой без материала, остаётся: `source_material_id IS NULL`.
	return usePowerSyncQuery<LocalVisualAnalysis>(
		`SELECT v.id, v.user_id, v.title, v.category, v.status, v.image_url,
		        v.created_at, v.updated_at, v.deleted_at
		   FROM visual_analyses v
		  WHERE v.user_id = ? AND v.deleted_at IS NULL
		    AND ${belongsToLiveMaterial("v", "source_material_id")}
		ORDER BY v.created_at DESC`,
		[userId ?? ""],
	);
}
